import { Component, EventEmitter, Input, Output } from '@angular/core';
import { QuarantinedDocument } from '../../constants/quarantined-document.constants';

@Component({
  selector: 'app-reject-quarantined-document-modal',
  templateUrl: './reject-quarantined-document-modal.component.html',
  styleUrls: ['./reject-quarantined-document-modal.component.scss']
})
export class RejectQuarantinedDocumentModalComponent {
   @Output() rejectQuarantinedDocuments = new EventEmitter<string>();
   @Output() isRejectQuarantinedDocumentModalVisible = new EventEmitter<boolean>();
  display: boolean = true;
  rejectQuarantinedDocumentHeader: string = QuarantinedDocument.QuarantineDocument_Reject_Confirmation_Header;
  requiredModalHeader: string = QuarantinedDocument.QuarantineDocument_Reject_Confirmation_Text;
  reasonForRejection:string = '';
  isRejectEnabled: boolean = false;
  
  onReasonForRejectionChange() {    
    if (this.reasonForRejection.trim() !== '') {
      this.isRejectEnabled = true;
    } else {
      this.isRejectEnabled = false;
    }
  }

  cancel() {
    this.display = false;
    this.isRejectQuarantinedDocumentModalVisible.emit(false);
  }
  
  rejectQuarantineDocuments() {
    this.isRejectQuarantinedDocumentModalVisible.emit(false);
    this.rejectQuarantinedDocuments.emit(this.reasonForRejection);
  }
}
